/** @jsxImportSource @emotion/react */
import { css, keyframes } from "@emotion/react";

const spSlices = keyframes`
  0% {
    border-top: 8px rgba(94, 93, 215, 0.75) solid;
    border-right: 8px rgba(94, 93, 215, 0.25) solid;
    border-bottom: 8px rgba(94, 93, 215, 0.25) solid;
    border-left: 8px rgba(94, 93, 215, 0.25) solid;
  }
  25% {
    border-top: 8px rgba(94, 93, 215, 0.25) solid;
    border-right: 8px rgba(94, 93, 215, 0.75) solid;
    border-bottom: 8px rgba(94, 93, 215, 0.25) solid;
    border-left: 8px rgba(94, 93, 215, 0.25) solid;
  }
  50% {
    border-top: 8px rgba(94, 93, 215, 0.25) solid;
    border-right: 8px rgba(94, 93, 215, 0.25) solid;
    border-bottom: 8px rgba(94, 93, 215, 0.75) solid;
    border-left: 8px rgba(94, 93, 215, 0.25) solid;
  }
  75% {
    border-top: 8px rgba(94, 93, 215, 0.25) solid;
    border-right: 8px rgba(94, 93, 215, 0.25) solid;
    border-bottom: 8px rgba(94, 93, 215, 0.25) solid;
    border-left: 8px rgba(94, 93, 215, 0.75) solid;
  }
  100% {
    border-top: 8px rgba(94, 93, 215, 0.75) solid;
    border-right: 8px rgba(94, 93, 215, 0.25) solid;
    border-bottom: 8px rgba(94, 93, 215, 0.25) solid;
    border-left: 8px rgba(94, 93, 215, 0.25) solid;
  }
`;

const loaderStyle = (size, borderWidth, duration) => css`
  width: ${size}px;
  height: ${size}px;
  border-radius: 50%;
  border-top: ${borderWidth}px rgba(94, 93, 215, 0.75) solid;
  border-left: ${borderWidth}px rgba(94, 93, 215, 0.25) solid;
  border-bottom: ${borderWidth}px rgba(94, 93, 215, 0.25) solid;
  border-right: ${borderWidth}px rgba(94, 93, 215, 0.25) solid;
  animation: ${spSlices} ${duration}s infinite linear;
`;

const DotLoader = ({ size = 50, borderWidth = 8, duration = 1 }) => {
  return <div css={loaderStyle(size, borderWidth, duration)} />;
};

export default DotLoader;
